"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _noty = require("noty");

var _commentForm = babelHelpers.interopRequireDefault(require("./comment-form"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _animationHelper = babelHelpers.interopRequireDefault(require("animation-helper"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var _S3FileUploadControl = require("./S3FileUploadControl");

var _class, _descriptor, _temp, _class3, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _temp2;

var PossibleErrorNode = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(PossibleErrorNode, _Component);

  function PossibleErrorNode() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, PossibleErrorNode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(PossibleErrorNode)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "discussion", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(PossibleErrorNode, [{
    key: "getErrorNode",
    value: function getErrorNode() {
      if (this.discussion.children.length) {
        if (this.discussion.children[0].node.child_type == 'videoPending' && this.discussion.children[0].node.error) return this.discussion.children[0].node;

        if (this.discussion.children[0].node.child_type == 'video') {
          var T = this.discussion.children[0].children.filter(function (node) {
            return node.node.child_type == 'reject';
          });
          if (T.length) return T[0].node;
        }
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var node = this.getErrorNode();
      if (!node) return null;

      switch (node.child_type) {
        case 'videoPending':
          return _react.default.createElement("div", {
            className: "alert alert-danger"
          }, "Your video '", node.video.split('/').pop(), "' could not be processed. Submit another and try again.");

        case 'reject':
          return _react.default.createElement("div", {
            className: "alert alert-warning maybe-linked"
          }, _react.default.createElement("div", null, node.account.fullName, " has requested that you submit another video."), node.comment ? _react.default.createElement("a", {
            className: "alert-link",
            href: location.href.split('#').shift() + '#comment-' + node.id,
            onClick: this.scrollToComment
          }, "View message") : null);
      }

      return null;
    }
  }, {
    key: "scrollToComment",
    value: function scrollToComment(event) {
      event.preventDefault();
      var node = this.getErrorNode();
      if (!node) return;
      var top = $('#comment-' + node.id).offset().top;
      var currentTop = $(window).scrollTop();
      new _animationHelper.default(300, 'ease-in-out', function (percent) {
        $(window).scrollTop(currentTop + percent * (top - currentTop));
      }).start();
    }
  }]);
  return PossibleErrorNode;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "discussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "scrollToComment", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "scrollToComment"), _class.prototype)), _class);
var ActivityRootNode = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(ActivityRootNode, _Component2);

  function ActivityRootNode() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, ActivityRootNode);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(ActivityRootNode)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "discussionRoot", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "commentPosted", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "discussion", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "trackData", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    _this2.componentIsMounted = false;
    _this2.state = {
      submitting: false,
      userProfile: null,
      video: null,
      videoUploadCallback: null,
      showUploadInstructions: null,
      generation: 1
    };
    return _this2;
  }

  babelHelpers.createClass(ActivityRootNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      this.componentIsMounted = true;
      (0, _userProfile.getUserProfile)().then(function (profile) {
        _this3.setState({
          userProfile: profile
        });
      });
      $(document).on('profileUpdated', this.profileUpdated);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.componentIsMounted = false;
      $(document).off('profileUpdated', this.profileUpdated);

      if (this.state.showUploadInstructions) {
        document.documentElement.removeEventListener('click', this.hideUploadInstructions);
      }
    }
  }, {
    key: "profileUpdated",
    value: function profileUpdated(event) {
      this.setState({
        userProfile: event.profile
      });
    }
  }, {
    key: "setUploadCallback",
    value: function setUploadCallback(callback) {
      this.setState({
        videoUploadCallback: callback
      });
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.setState(function (st) {
        return {
          video: null,
          videoUploadCallback: null,
          showUploadInstructions: false,
          generation: st.generation + 1
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.userProfile) return null;
      return _react.default.createElement("div", {
        className: this.state.video || this.state.videoUploadCallback ? 'comment-thread' : ''
      }, !this.state.video && !this.state.videoUploadCallback ? _react.default.createElement(PossibleErrorNode, {
        discussion: this.discussion
      }) : null, _react.default.createElement("article", {
        className: "comment-item assignment-item",
        "data-has-video": this.state.video || this.state.videoUploadCallback ? true : false
      }, _react.default.createElement("header", null, _react.default.createElement("div", {
        className: "photo"
      }, _react.default.createElement(_ProfileImageContainer.default, {
        className: "userProfilePhoto",
        noImageClassName: "default",
        image: this.state.userProfile.photo,
        name: this.state.userProfile.nickname || this.state.userProfile.fullName || ""
      })), _react.default.createElement("div", {
        className: "info-block"
      }, _react.default.createElement("div", {
        className: "person"
      }, _react.default.createElement("span", {
        className: "person-name"
      }, this.state.userProfile.nickname || this.state.userProfile.fullName || 'System')))), _react.default.createElement(_commentForm.default, {
        hidden: this.state.video || this.state.videoUploadCallback ? false : true,
        canSubmit: this.state.video || this.state.videoUploadCallback,
        submitComment: this.submitComment,
        userProfile: this.state.userProfile,
        submitting: this.state.submitting,
        placeholder: "Add a comment...",
        acceptEmptyComment: true,
        submitButtonText: "Upload",
        cancel: _react.default.createElement("button", {
          type: "button",
          className: "cancel-link",
          disabled: this.state.submitting,
          onClick: this.cancel
        }, "Cancel")
      }, _react.default.createElement(_S3FileUploadControl.S3FileUploadControl, {
        initialValue: this.state.video,
        setUploadCallback: this.setUploadCallback,
        generation: this.state.generation,
        accept: {
          extensions: ['3gp', 'avi', 'flv', 'm2ts', 'm4v', 'mp4', 'mpg', 'mpeg', 'mts', 'mov', 'wmv'],
          types: ['video/*']
        },
        buttonContent: "Select Video",
        buttonClass: "btn upload-btn",
        selectedButtonClass: "btn selected-upload-btn"
      })), !(this.state.video || this.state.videoUploadCallback) ? _react.default.createElement("div", {
        className: "upload-instructions"
      }, _react.default.createElement("a", {
        onClick: this.showUploadInstructions,
        href: "javascript:void(0)"
      }, "View Upload Instructions"), _react.default.createElement("div", {
        className: _classList.default.join('upload-instructions-content', this.state.showUploadInstructions === true ? 'open' : '', this.state.showUploadInstructions === false ? 'closed' : '')
      }, _react.default.createElement("p", null, "Click the 'Select Video' button to begin. Once your video is uploaded, it will begin processing. Videos must not exceed 3GB in size."), _react.default.createElement("p", null, "Acceptable file types are: 3gp, avi, flv, m2ts, m4v, mp4, mpg, mpeg, mts, mov, wmv"))) : null));
    }
  }, {
    key: "showUploadInstructions",
    value: function showUploadInstructions() {
      this.setState({
        showUploadInstructions: true
      });
    }
  }, {
    key: "hideUploadInstructions",
    value: function hideUploadInstructions() {
      this.setState({
        showUploadInstructions: false
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.showUploadInstructions != this.state.showUploadInstructions) {
        if (this.state.showUploadInstructions) document.documentElement.addEventListener('click', this.hideUploadInstructions);else document.documentElement.removeEventListener('click', this.hideUploadInstructions);
      }
    }
  }, {
    key: "doPostComment",
    value: function doPostComment(comment) {
      var _this4 = this;

      var P = this.state.videoUploadCallback || function () {
        return _promisePolyfill.default.resolve(_this4.state.video);
      };

      return P().then(function (videoName) {
        return (0, _fetch.default)('data/discussion/post', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            child_type: 'video',
            parent: _this4.discussionRoot.id,
            comment: comment,
            video: videoName,
            trackData: _this4.trackData
          })
        });
      }).then(function (result) {
        if (result.ok) return result.status == 204 ? true : result.json();
        return result.json().then(function (value) {
          throw value;
        });
      });
    }
  }, {
    key: "submitComment",
    value: function submitComment(comment) {
      var _this5 = this;

      return new _promisePolyfill.default(function (resolve, reject) {
        _this5.setState({
          submitting: true
        }, function () {
          _this5.doPostComment(comment).then(function (result) {
            (0, _noty.showNotificationText)('Your video has been uploaded.');

            _this5.commentPosted();

            if (_this5.componentIsMounted) {
              _this5.setState({
                submitting: false
              });
            }

            resolve(true);
          }).catch(function (error) {
            if (_this5.componentIsMounted) {
              _this5.setState({
                submitting: false
              });
            }

            ;
            reject(error);
          });
        });
      });
    }
  }]);
  return ActivityRootNode;
}(_react.Component), _temp2), (_descriptor2 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "discussionRoot", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "commentPosted", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "discussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "trackData", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "profileUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "profileUpdated"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "setUploadCallback", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "setUploadCallback"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "cancel", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "cancel"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "showUploadInstructions", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "showUploadInstructions"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "hideUploadInstructions", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "hideUploadInstructions"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "submitComment", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "submitComment"), _class3.prototype)), _class3);
exports.default = ActivityRootNode;